import * as ReactDOM from "react-dom";

import { BrowserRouter } from "react-router-dom";
import App from "./app";
import React from "react";
import { MuiThemeProvider } from "material-ui";
import ThemeDefault from "./theme-default";
import "./styles.scss";
import { Provider } from "react-redux";
import store from "./redux/store";

ReactDOM.render(
  <Provider store={store}>
    <MuiThemeProvider muiTheme={ThemeDefault}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </MuiThemeProvider>
  </Provider>,
  document.getElementById("root")
);
